<!--Map widget-->
<div class="map-content" [style.width]="'100%'" [style.height]="'100%'" [style]="containerStyle" #htmlContent>
  <div *ngIf="!isLoading()" [style]="blockStyle">
    @if (richTitle && showTitle) {
    <app-widget-title [title]="title" [design]="widget?.design?.title"></app-widget-title>
    } @else {
    <p [style]="titleStyle" *ngIf="showTitle">{{ title }}</p>
    }

    <span class="error" *ngIf="error">{{ error }}</span>

    <div class="map-container" #mapContainer>
      <google-map appMapTheme [options]="mapOptions" [width]="'100%'" [height]="'100%'">
      </google-map>

      <div id="legendMap" *ngIf="showLegend" [style]="legendStyle">
        <p *ngFor="let item of labelsWithColors">
          <span class="legend-color" [style.background-color]="item.color"></span>
          {{ item.label }}
        </p>
      </div>
    </div>
  </div>

  <app-widget-loading *ngIf="isLoading()" [graphType]="widget?.graphType"></app-widget-loading>

  <div id="chart-rendered" *ngIf="widgetRendered"></div>
</div>